import { useState, useEffect } from 'react';
import { withCache, buildUniqueKey, types } from '@sendpayments/js-utils/dist/services/caching';

// TODO review this pattern so instead of persisting in the cache with local storage we use a <CacheProvider>
// (same approach as <StepsProvider>) so we can manage and see the state changes. Same we need to think
// about the endpoint caching. So far is all good but this need to be picked up sooner than later.
const usePersistedState = (name, initialState) => {
  const { get, persist } = withCache(buildUniqueKey(name), { type: types.LOCAL_STORAGE, log: false });
  const [state, setState] = useState(get(() => initialState));

  useEffect(() => {
    persist(() => state);
  }, [state]);

  const resetState = () => {
    persist(() => initialState);
    setState(setState);
  };

  return [state, setState, resetState];
};

export default usePersistedState;
